import { ROUTE_DOCS_LANDS } from '@/common/constants';
import Filter from '@/components/filter/Filter';
import { Navbar } from '@/components/navbar';
import { Sidebar } from '@/components/sidebar';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import useLandStore from '../store/useLandStore';

export default function LandWrapper() {
  const { landList, landListLoading } = useLandStore();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="w-full h-screen overflow-hidden">
      <Navbar />
      <div className="flex">
        <Sidebar
          items={landList.content || []}
          isLoading={landListLoading}
          totalPages={landList.totalPages || 1}
          totalElements={landList.totalElements}
        />
        <ScrollArea className="w-full  bg-gray-100 ">
          <Filter
            isLands
            page={ROUTE_DOCS_LANDS}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            className={'border-b border-gray-200 py-2 pr-10 pl-6 bg-white'}
          />
          <ScrollArea className={`h-[calc(100vh-${isOpen ? '200' : '135'}px)]`}>
            <Outlet />
          </ScrollArea>
        </ScrollArea>
      </div>
    </div>
  );
}
